import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {changeUserCart, removefromCart} from '../cartDB';

class Order extends Component {

constructor(){
  super();
  this.state = {order : 1};
  this.incOrder = this.incOrder.bind(this);
  this.decOrder = this.decOrder.bind(this);
  this.deleteOrder = this.deleteOrder.bind(this);
}

incOrder() {
 // console.log(this.props.idRestaurant)

  var s=JSON.parse(localStorage.getItem('user')).uid
  this.setState({ order: this.state.order+1 }, () => {
   /* console.log(this.props.idRestaurant)
    console.log(this.props.order[0])
    console.log(this.state.order)*/

    changeUserCart(s, this.props.idRestaurant, this.props.order[0], this.state.order, this.props.order[1].item_price);
  });
}

decOrder() {
 // console.log(this.props.idRestaurant)

  var s=JSON.parse(localStorage.getItem('user')).uid
 if(this.state.order>1){
  this.setState({ order: this.state.order-1}, () => {
  /*  console.log(this.props.idRestaurant)
    console.log(this.props.order[0])
    console.log(this.state.order)*/
    changeUserCart(s, this.props.idRestaurant, this.props.order[0], this.state.order, this.props.order[1].item_price);
  });
 }
 else {
  this.setState({ order: this.state.order-1}, () => {
  removefromCart(JSON.parse(localStorage.getItem('user')).uid, this.props.idRestaurant, this.props.order[0]);
  });
 }
}

deleteOrder(){
  var s=JSON.parse(localStorage.getItem('user')).uid
  removefromCart(JSON.parse(localStorage.getItem('user')).uid, this.props.idRestaurant, this.props.order[0]);
  //changeUserCart(s, this.props.idRestaurant, this.props.order[0], this.state.order, this.props.order[1].item_price);
}


componentDidMount(){
  this.setState({order : this.props.order[1].quantity})
 // console.log(this.props.updated_product[this.props.order[1].variant.product_id]===this.props.order[1].variant.updated_at)
  if(this.props.updated_product[this.props.order[1].variant.product_id])
  if(this.props.order[1].variant.updated_at)
  if(this.props.updated_product[this.props.order[1].variant.product_id]===this.props.order[1].variant.updated_at)
  {


  }
  else{
    this.deleteOrder()
    console.log("delete")

  }
  //console.log(this.props.order[1].variant.product_id)
  //console.log(this.props.order[1].variant.updated_at)
}
componentWillReceiveProps(props)
{
 //console.log(props)
 if(props.updated_product[this.props.order[1].variant.product_id])
 if(props.order[1].variant.updated_at)
 if(props.updated_product[props.order[1].variant.product_id]===props.order[1].variant.updated_at)
  {


  }
  else{
    this.deleteOrder()
    console.log("delete")

  }
}
  render() {


    var extrasTitle = this.props.order[1].extras ? <strong>Extras:</strong>  : null
    var listExtras = this.props.order[1].extras ? Object.entries(this.props.order[1].extras).map((extra, index)  => {
    return  (index===0)?<span key = {extra[0]}> {extra[1].name} </span>:<span key = {extra[0]}> , {extra[1].name} </span>
    }) : null;

    var listOptions = this.props.order[1].options ? Object.entries(this.props.order[1].options).map((option, index) =>
      {return <span key = {Object.entries(option[1].elements)[0][0]}><strong>{option[1].name}</strong> : {Object.entries(option[1].elements)[0][1].name}<br/> </span>}
    ) : null;

   // console.log(this.props.order[1].extras)
    //console.log(this.props.order[1].options)
    return (
      <div className="order-row">
          <div className="widget-body">
              <div style={{    display: "block",
    padding: "2px 12px",
    textAlign: "left",
    marginBottom: 5
    ,
    marginTop:5}} className="title-row row">
                <div    className="col-xs-6 col-lg-6">
                <strong style={{fontSize:20}}> {this.state.order}x </strong>
                <span style={{fontSize:17}}> {this.props.order[1].variant.name}</span>
                </div>
                <div style={{fontSize:20}} className="col-xs-6 col-lg-6">
                  <i style={{color:"#ffad18"}} className="fa fa-minus-square countIcon " aria-hidden="true" onClick = {this.decOrder}></i>
                 
                  <i style={{marginLeft:5,marginRight:5,color:"#ffad18"}} className="fa fa-plus-square countIcon " aria-hidden="true" onClick = {this.incOrder}></i>

                  {this.props.order[1].item_price.toFixed(3)}  <Link to="#"><i style={{color:"#a41d23"}} className="fa fa-trash pull-right" onClick={this.deleteOrder}></i></Link>
                </div>
              </div>
           
              <div className="form-group row no-gutter">
                <div  style={{marginLeft:13}} className="col-xs-6 col-lg-12">
                 {extrasTitle}
                 {listExtras}
                </div>
                <div style={{marginLeft:13}} className="col-xs-6 col-lg-12">
                 {listOptions}
                </div>
              
              </div>
          </div>
      </div>
    )
  };
}

export default Order;



// WEBPACK FOOTER //
// ./src/container/Order.js